export const breakpoints = {
  sm: "600px",
  lg: "1024px",
}
